import { Icon } from '@ui';
import { Link } from 'react-router';
import { markNavigation } from './RouterLink';

/** "‹ Völker" above the title of a detail page (docs/ux-richtlinien.md §4). */
export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link to={to} viewTransition onClick={() => markNavigation('pop')}>
      <Icon name="chevron-left" size="sm" />
      {label}
    </Link>
  );
}
